import * as React from 'react'
import { Modal, Form } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import ItemForm from './ItemForm'
import { pipe, flow } from 'fp-ts/lib/function'
import { closeEditItemModal } from './types'
import { option, apply } from 'fp-ts'
import { useUpdateItem } from './queries'

const EditItemModal = () => {
  const updateItem = useUpdateItem()
  const editingItem = useSelector(s => s.items.editingItem)
  const visible = editingItem !== undefined
  const loading = updateItem.isLoading
  const dispatch = useDispatch()
  const [form] = Form.useForm()
  const closeModal = flow(closeEditItemModal, dispatch)

  React.useEffect(() => {
    if (visible) {
      form.resetFields()
    }
  }, [visible])

  return (
    <Modal
      zIndex={2}
      visible={visible}
      cancelText={<FormattedMessage id="cancel" />}
      okText={<FormattedMessage id="confirm" />}
      onCancel={closeModal}
      onOk={form.submit}
      okButtonProps={{ loading }}
      title={<FormattedMessage id="editItem" />}
      destroyOnClose={true}
    >
      <ItemForm
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        form={form}
        initialValues={editingItem}
        onFinish={item => {
          if (editingItem === undefined) {
            return
          }

          pipe(
            item,
            apply.sequenceS(option.Monad),
            option.fold(
              () => {},
              i =>
                updateItem.mutate(
                  { id: editingItem.id, ...i },
                  {
                    onSuccess: () => {
                      closeModal()
                    },
                  }
                )
            )
          )
        }}
      />
    </Modal>
  )
}

export default EditItemModal
